module.exports = __webpack_public_path__ + "static/img/huojian.6a8d98e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/huojian.png
// module id = VOKZ
// module chunks = 0